var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-container"
  }, [_vm._m(0), _c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('vertical-form-table', _vm._b({
    attrs: {
      "selectList": ['Smart farm product', 'Smart farm facility', 'Fresh food', 'General']
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false)), _c('page-section', {
    staticClass: "page-section--xxs pb-0"
  }, [_c('terms-of-agreements-short', {
    attrs: {
      "code": 'en-privacy-agree',
      "params": {
        codes: 'en-privacy-agree'
      }
    },
    on: {
      "isValid": function (_isValid) {
        function isValid(_x) {
          return _isValid.apply(this, arguments);
        }

        isValid.toString = function () {
          return _isValid.toString();
        };

        return isValid;
      }(function (isValid) {
        return _vm.isTermsValid = isValid;
      })
    },
    model: {
      value: _vm.form._terms,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "_terms", $$v);
      },
      expression: "form._terms"
    }
  })], 1), _c('div', {
    staticClass: "btn-wrap btn-wrap--lg"
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "auto"
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "w-100 min-w-sm-160px",
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('save');
      }
    }
  }, 'v-btn', {
    disabled: _vm.disabled
  }, false), [_vm._v("Submit")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-right pb-16px pb-md-20px"
  }, [_c('span', {
    staticClass: "red--text"
  }, [_vm._v("* ")]), _vm._v("Required to fill in ")]);
}]

export { render, staticRenderFns }